import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveUrl } from "~/utils/url/urlResolver";
import { AffiliatePartnerAPI } from "~/domains/affiliate/api/staticPaths";

interface ApiData {
  affiliateId: string;
  salesPartnerId?: string;
}

export const apiSavePreferredPartner = (data: ApiData) => {
  return fetch(resolveUrl(AffiliatePartnerAPI.HOST + AffiliatePartnerAPI.SAVE), {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      CSRFToken: getCsrfValue(),
      "content-type": "application/json",
    },
    redirect: "follow",
  });
};
export const apiDeletePreferredPartner = () =>
  fetch(resolveUrl(AffiliatePartnerAPI.HOST + AffiliatePartnerAPI.DELETE), {
    cache: "no-cache",
    credentials: "same-origin",
    method: "DELETE",
    mode: "cors",
    headers: {
      CSRFToken: getCsrfValue(),
      "content-type": "application/json",
    },
    redirect: "follow",
  });
